module.exports = __webpack_public_path__ + "static/media/count-9.61502520.mp3";